module.exports = __webpack_public_path__ + "img/risk-form.8864f327.png";